import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && !url.startsWith("/auth/login") && !url.startsWith("/public")) {
      localStorage.removeItem("rf_token");
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

// Order controls the sequential auto-share flow. Google is first because
// most mobile users are already logged into their Google account, which gives
// the highest conversion (90%+ complete). TripAdvisor often triggers a login
// popup that Safari/Chrome block, so it goes second and users can skip it.
export const PLATFORM_META = {
  google: { label: "Google", color: "#4285F4" },
  tripadvisor: { label: "TripAdvisor", color: "#00AA6C" },
  trustpilot: { label: "Trustpilot", color: "#00B67A" },
  facebook: { label: "Facebook", color: "#1877F2" },
};
